import React from 'react';

// UI
import DefaultLayout from '@ui/layouts/Default.layout';
import SharedFunnelDetails from '@app/marketing/components/SharedFunnelDetails';
import Logos from '@app/marketing/components/Logos';
import Testimonials from '@app/marketing/components/Testimonials';

// Types
import { ContentfulPageProps } from '@core/types';

export interface Props extends Omit<ContentfulPageProps, 'title' | 'description'> {
    children: any;
}

const SharedLayout: React.FC<Props> = ({ children, logoUrls, testimonials }) => {
    return (
        <DefaultLayout>
            <div className="flex flex-col space-y-12 lg:flex-row lg:space-x-12 lg:space-y-0">
                <div className="mt-12 flex-1">
                    <SharedFunnelDetails />
                </div>

                <div className="flex-shrink-0 rounded-2xl px-8 py-10 lg:border lg:shadow-xl">
                    {children}
                </div>
            </div>

            <Logos logos={logoUrls} />
            <Testimonials testimonials={testimonials} />
        </DefaultLayout>
    );
};

export default SharedLayout;
